import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-access-denied-page',
  standalone: true,
  imports: [],
  templateUrl: './access-denied-page.component.html',
  styleUrl: './access-denied-page.component.scss'
})
export class AccessDeniedPageComponent {

  constructor(private location: Location) { }

  goBack() {
    this.location.back();
  }

}
